import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP9BudgetCappedReorder: FaireAdCampaignEntity = {
  token: "camp_p9_budget_capped_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_p9_budget_capped",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 900,
  startedRunningAt: "2025-03-01",
  segmentMetrics: {
    numReorderConversions: 196,
    salesDollars: 53085,
    totalAdsSpendDollars: 5233,
    returnOnAdSpend: 10.14,
  },
  performancePeriodTokens: [
    "perf_p9_budget_capped_reorder_202512",
    "perf_p9_budget_capped_reorder_202601",
    "perf_p9_budget_capped_reorder_202602",
    "perf_p9_budget_capped_reorder_202603",
    "perf_p9_budget_capped_reorder_202604",
    "perf_p9_budget_capped_reorder_202605",
    "perf_p9_budget_capped_reorder_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
